module.exports = __webpack_public_path__ + "img/empty-state-card.e2170813.svg";